export default function CommentsSection() {
  const comments = [
    { id: 1, user: '吃瓜一线', avatar: 'C', time: '2小时前', content: '这个瓜保熟！看了三遍才理清人物关系，51黑料网整理得太清晰了，今日黑料最新进度全在上面追踪。', likes: 1283 },
    { id: 2, user: '娱乐圈观察员', avatar: '观', time: '5小时前', content: '每天必来刷一遍黑料每日更新，比微博热搜还全，51黑料今日的爆料速度真的没话说。', likes: 967 },
    { id: 3, user: '深夜吃瓜人', avatar: '瓜', time: '8小时前', content: '刚从隔壁过来，这里的黑料新鲜事更新频率绝了，已经推荐给身边所有八卦群的朋友。', likes: 745 },
    { id: 4, user: '真相挖掘机', avatar: '真', time: '12小时前', content: '作为老用户必须说一句：51黑料网入口收藏好，每日黑料不踩雷，信息筛选做得越来越专业了。', likes: 532 },
  ];

  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-accent-400 bg-accent-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-chat-3-line"></i>
            用户热评
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">看看大家对今日黑料最新爆料的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 border border-background-200/60 rounded-lg p-5 hover:border-background-300/60 transition-colors"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-500/20 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-400 font-semibold text-sm">{comment.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1.5">
                    <span className="text-sm font-semibold text-foreground-200">{comment.user}</span>
                    <span className="text-xs text-foreground-600">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-400 leading-relaxed">{comment.content}</p>
                  <div className="flex items-center gap-1 mt-3 text-xs text-foreground-600">
                    <i className="ri-heart-line text-accent-400"></i>
                    <span>{comment.likes.toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}